class CustomPrice extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updatePrice();
  }

  updatePrice() {
    var total = parseFloat(this.getAttribute('data-price')) || 0;

    // Pattern/yarn addon items (toggle-based)
    var addonItems = document.querySelectorAll('.addon-item.active--item');
    addonItems.forEach(item => {
      var quantitySelector = item.querySelector('.custom-quantity-selector');
      if (quantitySelector?.classList.contains('disabled')) return;

      var price = parseFloat(item.getAttribute('data-price')) || 0;
      var quantityInput = item.querySelector('.custom-quantity-input');
      var quantity = parseInt(quantityInput?.value, 10) || 0;
      total += price * quantity;
    });

    // Accessories items (add-to-order button based)
    var accessoryItems = document.querySelectorAll('.accessories__products .addon-item');
    accessoryItems.forEach(item => {
      var qtyWrap = item.querySelector('.accessories-qty-wrap');
      if (!qtyWrap || qtyWrap.style.display === 'none') return;

      var price = parseFloat(item.getAttribute('data-price')) || 0;
      var quantityInput = item.querySelector('.custom-quantity-input');
      var quantity = parseInt(quantityInput?.value, 10) || 0;
      total += price * quantity;
    });

    var priceDisplay = this.querySelector('.price-item');
    if (priceDisplay) {
      this.classList.remove('hidden');
      priceDisplay.textContent = `$${(total / 100).toFixed(2)}`;
    }
  }
}

customElements.define('custom-price', CustomPrice);